module.exports = __webpack_public_path__ + "static/media/bg_plan_suggestion_under_30.44c32cdd.webp";